export const TOKEN_KEY = 'token';
export const ACCOUNT_ID_KEY = 'accountId';
export const USER_ID_KEY = 'userId';
export const ROLE_KEY = 'role';
export const MAX_REFRESH_ATTEMPTS = 3;
